import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { login } from 'services/authentication';
import { markAsReadNotification } from 'hooks/auth/useUserNotifications';
import { useOpenGameCustomCode } from 'newhooks/generic/useOpenGameCustomCode';
import { useLoginCallback } from '../../Login/hooks/useLoginCallback';

export const LoginRelatedLogic = () => {
  const history = useHistory();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const openCasinoGame = useOpenGameCustomCode();

  const { loginCallback } = useLoginCallback({
    rememberMe: true,
    username,
    password
  });

  const sbLogin = (user: string, pass: string) => {
    setUsername(user);
    setPassword(pass);
  };

  window.SB = {
    openCasinoGame,
    historyPush: (path: string) => {
      history.push(path);
    },
    login: sbLogin,
    markAsReadNotification: markAsReadNotification
  };

  useEffect(() => {
    if (username && password) {
      login({ username, password }, loginCallback);
    }
  }, [username, password]);

  return null;
};
